module.exports = __webpack_public_path__ + "static/ankarapopup-f2a13c77f749c3fd19ff5b4bd538c388.png";